import { args } from '../../../common/args';
export const onSidebarOpen = {
  onSidebarOpen: {
    args: {
      isOpen: args.bool()
    }
  }
};